import styled from "@emotion/styled";
import { Link } from "../../Link";

export const Bold = styled.span`
  font-weight: bold;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 25px 1fr;
  align-items: flex-start;
  gap: 6px 12px;
  margin-top: 20px;
`;

export const GridIcon = styled.div`
  display: flex;
  justify-content: center;

  &:first-of-type {
    svg {
      margin-top: 2px;
    }
  }

  &:nth-of-type(2) {
    svg {
      margin-top: 4px;
    }
  }
`;

export const ProjectContent = styled.div`
  line-height: 1.4;
  flex-grow: 1;
`;

export const StyledLink = styled(Link)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.night};
  color: ${({ theme }) => theme.colors.night};
  hyphens: auto;
  text-decoration: none;
  overflow-wrap: anywhere;

  &:hover {
    border-bottom-color: ${({ theme }) => theme.colors.jungle};
    color: ${({ theme }) => theme.colors.jungle};
  }

  &:focus-visible {
    outline: 1px solid ${({ theme }) => theme.colors.night};
    border-radius: 2px;
  }
`;

export const Text = styled.p`
  margin-bottom: 4px;
`;

export const Title = styled.h3`
  font-size: 24px;
  font-weight: bold;
  line-height: 1.35;
  word-break: break-word;
`;

export const TitleWrapper = styled.div`
  display: flex;
  margin-bottom: 16px;

  @media ${({ theme }) => theme.bp.tabletUp} {
    max-width: 70%;
  }
`;
